export default "__VITE_ASSET__CriurcFI__"